import axios, { AxiosPromise } from 'axios'
import { getBaseUrl, getClientId, getLanguage, getStyle, getHostedSolutionAlias } from '../reducers/config';
import { getUrlTarget } from '../reducers/timings';
import { getLastEventIdByMatchId } from '../reducers/matches';
import { IState } from '../store/state';
import { getFeedBaseUrl } from '../reducers/bookmakerOptions';
import { IFishnetRankingData, IFishnetResponse } from '../api/fishnet/types';

const stringHash = require("string-hash");

export const promiseBookmakerOptions = (state: IState) : Promise<any> => 
    axios.get(`${getBaseUrl(state)}mobile/bookmakerOptions?clientid=${getClientId(state)}&lang=${getLanguage(state)}&style=${getStyle(state)}&h=${stringHash(location.host)}`);

export const promiseTranslations = (state: IState) : Promise<any> => 
    axios.get(`${getBaseUrl(state)}mobile/translations?clientid=${getClientId(state)}&lang=${getLanguage(state)}`);

//TODO: This feed can be removed?
export const promisePlayerStats = (state: IState) : Promise<any> => 
    axios.get(`${getFeedBaseUrl(state)}/${getUrlTarget(state)}/feeds/?/srvirtualgaming/en/Europe:Berlin/gismo/stats_team_info/153601`)
        
    
//TODO: teamIdA && teamIdB == club_id -> has to be verified with final scout
export const promiseStatsTeamVersusRecent = (state: IState, teamIdA: number, teamIdB: number, channel: number, numMatches: number = 5) : Promise<any> => 
    new Promise<any>(
        (resolve,reject) =>
            axios
            .get(`${getFeedBaseUrl(state)}/${getUrlTarget(state)}/feeds/?/${getHostedSolutionAlias(state)}/${getLanguage(state)}/Europe:Berlin/gismo/stats_team_versusrecent/${teamIdA}/${teamIdB}/${numMatches}`)
            .then( response => resolve( { data: { [channel]: response.data } } ) )
            .catch( error => reject(error) )
    )
    
export const promiseStatsTeamLastX = (state: IState, teamId: number, numMatches: number = 5) : Promise<any> => 
    axios.get(`${getFeedBaseUrl(state)}/${getUrlTarget(state)}/feeds/?/${getHostedSolutionAlias(state)}/${getLanguage(state)}/Europe:Berlin/gismo/stats_team_lastx/${teamId}/${numMatches}`);

export const promiseStatsPlayerAggregate = (state: IState, tournamentId: number, teamId: number, matchId: number) : Promise<any> => 
    axios.get(`${getFeedBaseUrl(state)}/${getUrlTarget(state)}/feeds/?/${getHostedSolutionAlias(state)}/${getLanguage(state)}/Europe:Berlin/gismo/vti_stats_uniquetournament_player_aggregate/${tournamentId}/${teamId}/${matchId}`);

export const promiseStatsRanking = (state: IState, tournamentId: number) : AxiosPromise<IFishnetResponse<IFishnetRankingData>> => 
    axios.get(`${getFeedBaseUrl(state)}/${getUrlTarget(state)}/feeds/?/${getHostedSolutionAlias(state)}/${getLanguage(state)}/Europe:Berlin/gismo/vto_ranking/${tournamentId}`);

export const promiseMatchEvents = (state: IState, matchId: number) : Promise<any> => 
    axios.get(`${getFeedBaseUrl(state)}/${getUrlTarget(state)}/feeds/?/${getHostedSolutionAlias(state)}/${getLanguage(state)}/Europe:Berlin/gismo/match_timeline/${matchId}`);

export const promiseMatchEventsDelta = (state: IState, matchId: number) : Promise<any> => 
    axios.get(`${getFeedBaseUrl(state)}/${getUrlTarget(state)}/feeds/?/${getHostedSolutionAlias(state)}/${getLanguage(state)}/Europe:Berlin/gismo/vg_match_timelinedelta/${matchId}/${getLastEventIdByMatchId(state,matchId)}`);

export const promiseMatchGet = (state: IState, matchId: number) : Promise<any> => 
    axios.get(`${getFeedBaseUrl(state)}/${getUrlTarget(state)}/feeds/?/${getHostedSolutionAlias(state)}/${getLanguage(state)}/Europe:Berlin/gismo/match_get/${matchId}`);

export const promiseMatchOdds = (state: IState, matchId: number) : Promise<any> => 
    axios.get(`${getFeedBaseUrl(state)}/${getUrlTarget(state)}/feeds/?/${getHostedSolutionAlias(state)}/${getLanguage(state)}/Europe:Berlin/gismo/match_odds2_with_odds_activation_status/vti:match:${matchId}?filtersettled=true`);

export const promiseMatchDetailsExtended = (state: IState, matchId: number) : Promise<any> => 
    axios.get(`${getFeedBaseUrl(state)}/${getUrlTarget(state)}/feeds/?/${getHostedSolutionAlias(state)}/${getLanguage(state)}/Europe:Berlin/gismo/vti_match_detailsextended/${matchId}`); 
